import { useAsyncData, useNuxtApp } from '#imports'
import { computed } from 'vue'

import { useBuybackOffer } from '@backmarket/nuxt-layer-buyback/app/scopes/offer/composables/useBuybackOffer/useBuybackOffer'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { removeEmptyValuesInObject } from '@backmarket/utils/object/removeEmptyValuesInObject'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchServicePickers() {
  const nuxtApp = useNuxtApp()

  const { productId, mobilePlan } = useUrlParams()
  const $httpFetch = useHttpFetch()
  const { buybackOffer } = useBuybackOffer()

  const servicePickersQueryParams = computed(() => {
    return removeEmptyValuesInObject({
      mobile_plan_offer_id: mobilePlan.value ? String(mobilePlan.value) : null,
    })
  })

  return useAsyncData(
    () =>
      getAsyncDataKey('pp-service-pickers', {
        productId,
        mobilePlan: mobilePlan.value,
        buybackOffer: buybackOffer.value?.listing.listingPublicId,
      }),
    async () =>
      $httpFetch('/product-page/products/:productId/services/pickers', {
        pathParams: { productId },
        query: servicePickersQueryParams.value,
      }),
    {
      // Services pickers currently returns mobile plan & trade-in pickers. They're only called
      // client-side as they rely on user's session (especially the trade-in one, that checks the user's cart),
      // meaning that we can't cache their response.
      server: false,
      // Use immediate:false and watch:false to activate the kill switch on this endpoint.
      lazy: true,
      dedupe: 'defer',
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )
}
